import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useCreateBranchMutation } from "store/services/branchApi";
import BranchForm from "./branchComponents/BranchForm";

const BranchCreateScreen = () => {
  const navigate = useNavigate();

  const [createBranch, { isLoading: creatingBranch }] =
    useCreateBranchMutation();

  const handleBranchCreate = async (data) => {
    try {
      await createBranch(data).unwrap();
      navigate("/app/crm/branch/list");
      toast.success("Branch created successfully");
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong!");
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={[
        { title: "Branches", path: "/app/crm/branch/list" },
        { title: "New Branch" },
      ]}
      isBusy={creatingBranch}
    >
      <BreadcrumbLayout.Paper>
        <BranchForm isBusy={creatingBranch} onSubmit={handleBranchCreate} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BranchCreateScreen;
